// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"styles_bottomNav__e-zU_"};